"use client";

import { PropsWithChildren, useEffect, useState } from "react";
import { useTrackVisibility } from "react-intersection-observer-hook";

type Props = {
  onLoadMore: () => void;
  loader: React.ReactNode;
  hasMore: boolean;
  loading?: boolean;
  className?: string;
  dataTestId?: string;
};

export const Scrollable = ({
  children,
  hasMore,
  onLoadMore,
  loader,
  loading = false,
  className,
  dataTestId = "",
}: PropsWithChildren<Props>) => {
  const [ref, { isVisible }] = useTrackVisibility();
  const [isLoading, setIsLoading] = useState<boolean>(loading);

  useEffect(() => {
    const getMore = async () => {
      setIsLoading(true);
      await onLoadMore?.();
      setIsLoading(false);
    };

    if (!isVisible || isLoading) return;

    getMore?.();
  }, [isLoading, isVisible, onLoadMore]);

  return (
    <div className={className} data-testid={dataTestId}>
      {children}
      {hasMore && isLoading ? loader : null}
      <div ref={ref} data-testid="scroll-ref"></div>
    </div>
  );
};
